import React, { Component } from 'react';
import './KPI7GraphMode.css';
import { connect } from 'react-redux';
import Select from '@acri-tools/react-tools/components/Select/Select';
import classNames from 'classnames';



interface Props {
    products:Array<any>
    disabled?: boolean

    // CALLBACKS
    on_add?:()=>void
    update?:(updates:any)=>void
    remove?:(idx:number)=>void
    // REDUX
    product_types?:any
}
interface State{
}

// const MODES = [ 'NRT', 'NTC', 'STC' ]

class KPI7GraphMode extends Component<Props, State>{
    constructor(props:Props){
        super(props);
    }

    render() {
        let product_types = this.props.product_types?.product_types ? Object.keys(this.props.product_types?.product_types) : null;
        return (
            <div className="create-graph-modes">
                {
                    this.props.products.map((p:any, idx:number)=>(
                        <div className="create-graph-mode" key={idx}>
                            {
                                product_types &&
                                <Select
                                    search
                                    className={classNames({
                                        "product-type-select": true,
                                        "disabled": this.props.disabled
                                    })} 
                                    value={p.product_type} 
                                    options={product_types?.map((pt:string)=>{ return { label: pt, value: pt } })}
                                    onChange={(select:string)=>{
                                        p.product_type = select;
                                        this.forceUpdate();
                                        this.props.update?.({ product_type: select })
                                    }}
                                />
                            }
                            {/* <Select
                                className={classNames({
                                    "disabled": this.props.disabled
                                })} 
                                value={p.mode} 
                                options={MODES.map((m)=>{ return { label:m, value:m  } })}
                                onChange={(select:string)=>{
                                    p.mode = select;
                                    this.forceUpdate();
                                    this.props.update?.({ mode: select })
                                }}
                            />
                            <Select
                                className={classNames({
                                    "product-type-select": true,
                                })} 
                                value={p.pug} 
                                options={[{ label: 'true', value: true }, { label: 'false', value: false }]}
                                onChange={(select:string)=>{
                                    p.pug = select;
                                    this.forceUpdate();
                                    this.props.update?.({ pug: select })
                                }}
                            /> */}
                            {
                                this.props.remove &&
                                <div className="custom-button icon-only small red" onClick={()=>{ this.props.remove?.(idx)}}>
                                    <i className="fas fa-times"/>
                                </div>
                            }
                        </div>
                    ))
                }

                {
                    product_types &&
                    this.props.on_add &&
                    <div className="centered">
                        <div 
                            className="custom-button alt inline small green" 
                            onClick={()=>{
                                let { products } = this.props;
                                products.push({
                                    product_type: Object.keys(this.props.product_types.product_types)?.[0],
                                    // mode: 'NRT',
                                    // pug: false
                                })
                                this.props.on_add?.();
                                this.forceUpdate();
                            }}
                            >
                            <i className="fas fa-plus"/> ADD
                        </div>
                    </div>
                }
            </div>
        )
    }
};

export default connect((state:any)=>{
    return{
        product_types: state.product_types
    }
})(KPI7GraphMode)